import { CoreAppState } from '../state/core-app.state';
import { BaseResourceService, httpOptions } from './base-resource.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { OrderCardResourceTypeMappings } from '@aa/nest/resource';
import { environment } from '../environments/environment';

@Injectable()
export class OrderCardService extends BaseResourceService<OrderCardResourceTypeMappings> {
  constructor(
    protected override readonly http: HttpClient,
    protected override readonly store: Store<CoreAppState>,
  ) {
    super(http, store, 'order-cards');
  }

  notifyCustomerOfCardChanges(id: number) {
    return this.http.post<any>(
      `${environment.resourceService}/order-cards/${id}/notify-customer`,
      {},
      httpOptions,
    );
  }

  approveCardChanges(id: number, messageId: number, metadata: Record<string, any>) {
    return this.http.post<any>(
      `${environment.resourceService}/order-cards/${id}/approve-changes`,
      { messageId, metadata },
      httpOptions,
    );
  }

  rejectCardChanges(id: number, messageId: number, metadata: Record<string, any>) {
    return this.http.post<any>(
      `${environment.resourceService}/order-cards/${id}/reject-changes`,
      { messageId, metadata },
      httpOptions,
    );
  }
}
